import 'whatwg-fetch';

import { getToken } from '../helpers/common';

// export const host = "https://seris-ram.com";
// // export const host = "https://test.seris-ram.com";
// // export const host = "http://localhost:8080";

// Keep API and authentication requests on the same origin as the portal.
// This works with the development proxy and avoids CSP/CORS differences
// between the www, non-www, test, and production hostnames.
export const host = window.location.origin;
console.log(window.location.origin);

export const rootApi = `${host}/api`;
export const googleapiskey = "AIzaSyCQZu6S5GTgnfo3oTYaflEA4ee6REex_Is";

const prepareRequest = (url, data, type, contentType) => {
  return fetch(url, {
    method: type,
    headers: {
      'Content-Type': contentType || 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify(data)
  });
}

const formPrepareRequest = (url, data, type) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", getToken());

  var formdata = new FormData();

  if (data.refslowdatajson) { formdata.append("jsonFile", data.refslowdatajson) }
  if (data.refcapacitydatajson) { formdata.append("jsonFile", data.refcapacitydatajson) }
  if (data.reffastdatajson) { formdata.append("jsonFile", data.reffastdatajson) }

  if (data.id) { formdata.append("id", data.id) }
  formdata.append("name", data.name);
  formdata.append("status", data.status);
  formdata.append("location", data.location);
  formdata.append("country", data.country);
  formdata.append("city", data.city);
  formdata.append("longitude", data.longitude);
  formdata.append("latitude", data.latitude);
  if (data.projectName) { formdata.append("projectName", data.projectName) }
  formdata.append("description", data.description);

  var requestOptions = {
    method: type,
    headers: myHeaders,
    body: formdata
  };

  return fetch(url, requestOptions)
}

export const fetchGet = url => {
  return fetch(url, {
    headers: {
      'Authorization': getToken()
    }
  })
    .then(checkHttpStatus)
    .then(response => response.json());
}

export const fetchGetText = url => {
  return fetch(url, {
    headers: {
      'Authorization': getToken()
    }
  })
    .then(response => response)
    .catch((error) => console.error(error));
}

export const fetchStationTimeOffset = (timestampInSeconds, lat, lng) => fetch(`https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestampInSeconds}&language=es&key=${googleapiskey}`)
  .then(response => response.json());

export const fetchPost = (url, data) => {
  return prepareRequest(url, data, 'POST')
    .then(checkHttpStatus)
    .then(response => response.json());
}

export const fetchPostFile = (url, data) => {
  return formPrepareRequest(url, data, 'POST')
    .then(checkHttpStatus)
    .then(response => response.json());
  // .then(response => response.text());
}

export const fetchPostText = (url, data) => {
  return prepareRequest(url, data, 'PUT', 'text/plain')
    .then(checkHttpStatus)
    .then(response => response.json());
}

export const fetchPutText = (url, data) => {
  return prepareRequest(url, data, 'POST', 'text/plain')
    .then(checkHttpStatus)
    .then(response => response.json());
}

export const fetchPut = (url, data) => {
  return prepareRequest(url, data, 'PUT')
    .then(checkHttpStatus)
    .then(response => response.json());
}

export const fetchDelete = (url) => {
  return fetch(url, { method: 'DELETE' })
    .then(checkHttpStatus)
    .then(response => response.json());
}

export const checkHttpStatus = response => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText || 'Error')
    error.status = response.status
    throw error;
  }
}